import $ from 'jquery'

export const init = async function (): Promise<void> {
  $('.Faq-question').on('click', function () {
    $(this).next('.Faq-answer').toggleClass('open')
    $(this).children('.Faq-square').first().toggleClass('open')
  })

  $('#js-faq-btn').on('click', function () {
    $('.Faq-answer').addClass('open')
    $('.Faq-square').addClass('open')
  })
}
